import { basename } from './i18n';

/**
 * Client HTTP de la SPA Premium.
 * Toutes les routes sont préfixées par la locale courante (basename),
 * l'authentification repose sur le cookie de session existant.
 */
async function request(path, options = {}) {
    const response = await fetch(`${basename}${path}`, {
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            // Convention maison : cet en-tête exempte la requête du contrôle CSRF
            // (voir Goibniu\Middleware\CSRFMiddleware)
            'Axios-Ajax': '1',
            ...(options.body && !(options.body instanceof FormData)
                ? { 'Content-Type': 'application/json' }
                : {}),
        },
        ...options,
    });

    // Session expirée : le ForbiddenMiddleware redirige vers la page de login
    if (response.status === 401 || response.status === 403
        || (response.redirected && response.url.includes('/login'))) {
        window.location.assign(`${basename}/login`);
        throw new Error('unauthenticated');
    }
    if (!response.ok) {
        let message = `HTTP ${response.status}`;
        try {
            const data = await response.json();
            message = data.error || message;
        } catch (e) { /* réponse non JSON */ }
        throw new Error(message);
    }
    return response.json();
}

export const api = {
    me: () => request('/api/me'),
    places: () => request('/api/places'),
    place: (id) => request(`/api/places/${id}`),
    updatePlace: (id, data) => request(`/api/places/${id}`, {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    addPhoto: (id, file) => {
        const form = new FormData();
        form.append('photo', file);
        return request(`/api/places/${id}/photos`, { method: 'POST', body: form });
    },
    updatePhoto: (id, data) => request(`/api/places/${id}/photos/update`, {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    reviews: (id) => request(`/api/places/${id}/reviews`),
    updateLocation: (id, lat, lng) => request(`/api/places/${id}/location`, {
        method: 'POST',
        body: JSON.stringify({ lat, lng }),
    }),
    statsEvents: (id, days) => request(`/stats/events/${id}?days=${days}`),
};
